import { render, staticRenderFns } from "./ActiveQuestions.vue?vue&type=template&id=26c165a0&scoped=true"
import script from "./ActiveQuestions.vue?vue&type=script&lang=js"
export * from "./ActiveQuestions.vue?vue&type=script&lang=js"
import style0 from "./ActiveQuestions.vue?vue&type=style&index=0&id=26c165a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c165a0",
  null
  
)

export default component.exports